Vendd.Scripts.load(function () {

    // if (isTouch()) {
    //     initMobileMenus();
    // } else {
    //     initMainMenu();
    // }
    //Treat main menu as touch
    initMobileMenus();
    initSecondaryMenu();
    initCarSubMenu();

    //Custom Forms
    // openCustomForm();

    function openCustomForm() {
        if (window.location.href.indexOf('#') > 0) {
            var query,form,brand,model;
            query = window.location.href
                    .slice(window.location.href.indexOf('#') + 1);
            form = query.slice(0, query.indexOf('?'));
            brand = query.slice(query.indexOf('brand=') + 6,query.indexOf('&'));
            model = query.slice(query.indexOf('model=') + 6);
            if (form) {
                brandVal = brand;
                brandText = brand;
                modelText = model;
                modelVal = model;
                formType = form;

                bookingForm.reset();
                bookingForm.handleErrors();
                bookingForm.updateBrand(brandVal, brandText);
                bookingForm.updateModel(modelVal,modelText);
                bookingForm.updateType(formType,0);
                bookingForm.show(true);
            }
        }
    }

    function initMainMenu() {
        var $wrapper = $('.main-menu', '.header-region');

        var $firstLevel = $('.nav-1 > li > a, .nav-1 > li > span', $wrapper);
        var $secondLevel = $('.nav-2 > li > a , .nav-2 > li > span', $wrapper);

        initMainMenuEffects($firstLevel);
        initMainMenuEffects($secondLevel);

        $('.nav-1', $wrapper).mouseleave(function () {
            $firstLevel.parent().removeClass('hovered');
        });

        $('.nav-2', $wrapper).mouseleave(function () {
            $secondLevel.parent().removeClass('hovered');
        });
    }

    function initSecondaryMenu() {

        var $secMenuwrapper = $('.secondary-menu', '.header-region');
        var $secMenuButton = $('.hasChildren > a, .hasChildren > span', $secMenuwrapper);

        menuButtonHandler($secMenuButton);

        $(document).click(function (event) {
            if ((!$(event.target).closest('.secondary-menu').length &&
                 !$(event.target).hasClass('js-car-submenu-close') &&
                 !$(event.target).is('.secondary-menu'))) {

                $('.hovered', '.secondary-menu').removeClass('hovered hidden');
            }
        });
    }

    function initCarSubMenu() {
        var $wrapper = $('.main-menu');
        $('.js-car-submenu-open', $wrapper).on('click', function(){
            car_submenu = $(this).siblings('.js-car-submenu').clone();
            $('.nav-2.megamenu li', $wrapper).hide();
            $('.nav-2.megamenu', $wrapper).append(car_submenu);
            car_submenu.addClass('shown');
            $('.js-car-submenu-close', car_submenu).on('click', function(){
                $('.nav-2.megamenu > .js-car-submenu', $wrapper).remove();
                $('.nav-2.megamenu li', $wrapper).show();
            })
            $('.nav-4 li', car_submenu).mouseenter(function () {
                $(this).addClass('hovered');
                $(this).closest('.megamenu').addClass('hovered');
            });

            $('.nav-4 li', car_submenu).mouseleave(function () {
                $(this).removeClass('hovered');
                $(this).closest('.megamenu').removeClass('hovered');
            });
        })
    }

    function initMainMenuEffects($submenus) {

        if ($submenus.length == 0)
            return;

        var config = {
            sensitivity: 50,
            interval: 60,
            over: mouseenter,
            timeout: 10,
            out: mouseleave
        };

        function mouseenter() {
            var $el = $(this);

            $el.siblings(".hovered").removeClass('hovered hidden');
            $el.addClass('hovered').siblings('.hovered').removeClass('hovered');
            $('.hovered', '.secondary-menu').removeClass('hovered');
        }

        function mouseleave() {
            return;
        }

        $submenus.parent().hoverIntent(config);
    }

    function initMobileMenus() {
        var $mainMenuwrapper = $('.main-menu', '.header-region');
        $('.nav-3 li', $mainMenuwrapper).mouseenter(function () {
            $(this).addClass('hovered');
            $(this).closest('.megamenu').addClass('hovered');
        });

        $('.nav-3 li', $mainMenuwrapper).mouseleave(function () {
            $(this).removeClass('hovered');
            $(this).closest('.megamenu').removeClass('hovered');
        });

        //var $secMenuwrapper = $('.secondary-menu', '.header-region');

        var $mainMenuButton = $('.hasChildren > a, .hasChildren > span', $mainMenuwrapper);
        //var $secMenuButton = $('.hasChildren > a, .hasChildren > span', $secMenuwrapper);

        menuButtonHandler($mainMenuButton);
        //menuButtonHandler($secMenuButton);

        $('.mobile-inactive', $mainMenuwrapper).on('click', function (e) {
            if ($(window).width() < 960) {
                e.preventDefault();
            }
        });

        $(document).click(function (event) {
            if ((!$(event.target).closest('.main-menu').length &&
               !$(event.target).is('.main-menu')) &&
               !$(event.target).hasClass('js-car-submenu-close') &&
               (!$(event.target).closest('.secondary-menu').length &&
               !$(event.target).is('.secondary-menu'))) {

                $('.hovered', '.main-menu').removeClass('hovered hidden');
            }
        });
    }

    function menuButtonHandler($menuButton) {
        var $wrapper = $('.main-menu', '.header-region');

        $menuButton.on('click', function (e) {
            e.stopPropagation();
            if (!$(this).hasClass('has-url')) {
                e.preventDefault();
            }

            var $this = $(this),
                $parent = $this.parent();

            if ($parent.hasClass('hovered')) {
                $parent.removeClass('hovered hidden').find('.hovered').removeClass('hovered hidden');
            } else {
                $parent.addClass('hovered').siblings().removeClass('hovered hidden');

                if ($(window).width() < 960) {
                    $('html, body').animate({ scrollTop: $('.main-menu').offset().top }, 100, 'swing');
                }
            }

            $('.nav-2.megamenu > .js-car-submenu', $wrapper).remove();
            $('.nav-2.megamenu li', $wrapper).show();
        });

    }
});

